import { KNM_FILE_SIZE_ERROR_DETAILED, KNM_FILE_SIZE_ERROR_SMALL } from 'CorePackage/MainModule/constants/notices';

import { addNoticeAction } from '../actions/NoticeActions';
import { MessageTypesEnum } from '../enums/MessageTypesEnum';
import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';

export const addNoticeKnmFileSizeErrorSmall = () =>
  addNoticeAction({
    renderContent: KNM_FILE_SIZE_ERROR_SMALL,
    noticeType: NoticeTypesEnum.ERROR,
    messageType: MessageTypesEnum.KNM_FILE_SIZE,
  });

export const addNoticeKnmFileSizeErrorDetailed = (maxFileSize: number) =>
  addNoticeAction({
    renderContent: `${KNM_FILE_SIZE_ERROR_DETAILED} ${maxFileSize}МБ`,
    noticeType: NoticeTypesEnum.ERROR,
    messageType: MessageTypesEnum.KNM_FILE_SIZE,
  });
